import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { getPCA } from "./apiUtils";
import 'bootstrap/dist/css/bootstrap.css';

// force build - 

const pca = getPCA();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App msalInstance={pca} />
  </React.StrictMode>
);
